export default function validateCEP(value: string): boolean | string {
  const cep = value.replace(/[^\d]+/g, '')

  if (!/^\d{8}$/.test(cep)) {
    return 'CEP inválido'
  }

  return true
}
